import Vue from "vue";
import Router from "vue-router";
import HomePage from "@/views/HomePage.vue";
import ConsolePanel from "@/views/ConsolePanel.vue";
Vue.use(Router);

const routes = [
  {
    path: "/",
    redirect: "/HomePage", // RedemptionPage
  },
  {
    path: "/HomePage",
    name: "HomePage",
    component: HomePage,
  },
  {
    path: "/LoginPage",
    name: "LoginPage",
    component: () => import("@/views/LoginPage.vue"),
  },
  {
    path: "/RegisterPage",
    name: "RegisterPage",
    component: () => import("@/views/RegisterPage.vue"),
  },
  {
    path: "/ForgotPassword",
    name: "ForgotPassword",
    component: () => import("@/views/ForgotPassword.vue"),
  },
  {
    path: "/ResetPassword",
    name: "ResetPassword",
    component: () => import("@/views/ResetPassword.vue"),
  },
  {
    path: "/TextTranslation",
    name: "TextTranslation",
    component: () => import("@/views/TextTranslation.vue"),
  },
  {
    path: "/VoicePage",
    name: "VoicePage",
    component: () => import("@/views/VoicePage.vue"),
  },
  {
    path: "/ConsolePanel",
    name: "ConsolePanel",
    component: ConsolePanel,
  },
  {
    path: "/PayPage",
    name: "PayPage",
    component: () => import("@/views/PayPage.vue"),
  },
  {
    path: "/StripePay",
    name: "StripePay",
    component: () => import("@/views/StripePay.vue"),
  },
  {
    path: "/PayResult",
    name: "PayResult",
    component: () => import("@/views/PayResult.vue"),
  },
  {
    path: "/FAQPage",
    name: "FAQPage",
    component: () => import("@/views/FAQPage.vue"),
  },
  {
    path: "/IntelligentAgent",
    name: "IntelligentAgent",
    component: () => import("@/views/IntelligentAgent.vue"),
  },
  {
    path: "/APIPage",
    name: "APIPage",
    component: () => import("@/views/APIPage.vue"),
  },
  {
    path: "/OrderPage",
    name: "OrderPage",
    component: () => import("@/views/OrderPage.vue"),
  },
  {
    path: "/APIPage2",
    name: "APIPage2",
    component: () => import("@/views/APIPage2.vue"),
  },
];

const router = new Router({
  mode: "hash",
  routes,
  scrollBehavior: () => ({ y: 0 }),
});

export default router;
